import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../../shared/shared.module';
import { InvoiceRegisterContainerComponent } from '.';
import { InvoiceRegisterPresenter } from './invoice-register-presenter';
import { InvoiceRegisterRoute } from './invoice-register.route';
import { InvoiceRegisterFiltersPresenterComponent } from './invoice-register-filters-presenter/invoice-register-filters-presenter.component';

@NgModule({
    declarations: [
        InvoiceRegisterContainerComponent,
        InvoiceRegisterPresenter,
        InvoiceRegisterFiltersPresenterComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [InvoiceRegisterRoute]
        })
    ]
})
export class InvoiceRegisterModule {}
